<template>
    <!--This layout is used to define the basic structure of all the pages (views) a user can access after logging in -->
    <!-- @modified ana.castro 2019.12.03 The Login interface must display a link to access the Terms and Conditions -->
    <!-- In case a Non Authenticated User access the Terms and Conditions page, the menu should not be displayed -->
    <v-navigation-drawer v-model="drawerClone" fixed clipped class="grey lighten-1" app>
        <v-spacer class="my-2"></v-spacer>
        <v-list dense class="grey lighten-1" v-if="loggedIn">
            <template v-for="(item, i) in items">
                <v-layout v-if="i.heading && i.enabled" :key="i" row align-center>
                </v-layout>
                <v-divider v-else-if="item.divider" :key="i" class="my-3 grey lighten-2"></v-divider>
                <v-spacer v-else-if="item.spacer" :key="i" class="my-5"></v-spacer>

                <v-list-tile v-else-if="item.enabled && !item.subgroups" :key="i" :to="item.route?item.route:''"
                             @click="item.function?handle_function_call(item.function):''" class="my-4">
                    <v-list-tile-action v-if="item.icon">
                        <v-icon
                                :class="item.route === $route.meta.parentMenuPath ? 'font-weight-bold primary--text' : 'grey--text text--darken-4'"
                        >{{ item.icon }}
                        </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <!--                        <v-badge inline v-if="!displayMenuCatalog && i==='catalog' && shopAvailable">-->
                        <!--                            <template v-slot:badge><span>{{ cartNumberItems }}</span></template>-->

                        <!--                            <v-list-tile-title class="white&#45;&#45;text text-uppercase">-->
                        <!--                                {{ $vuetify.t(item.text) }}-->
                        <!--                            </v-list-tile-title>-->
                        <!--                        </v-badge>-->
                        <!--                        <v-list-tile-title v-if="i!=='catalog' || !shopAvailable" class="white&#45;&#45;text text-uppercase">-->
                        <!--                            {{ $vuetify.t(item.text) }}-->
                        <!--                        </v-list-tile-title>-->
                        <v-list-tile-title class="text-uppercase">
                            {{ $vuetify.t(item.text) }}
                        </v-list-tile-title>

                    </v-list-tile-content>
                    <v-list-tile-action v-if="!displayMenuCatalog && i==='catalog' && shopAvailable">
                        <v-chip v-if="cartNumberItems > 0" color="primary" text-color="primary">{{ cartNumberItems }}
                        </v-chip>
                    </v-list-tile-action>
                </v-list-tile>


                <v-list-group
                        v-if="displayMenuCatalog && item.subgroups"
                        :key="i"
                        no-action
                >
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title class="text-uppercase">{{ item.text }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>

                    <v-list-tile
                            v-for="subGroup in item.subgroups"
                            :key="subGroup.id"
                            :to="subGroup.route?subGroup.route:''"
                    >
                        <v-list-tile-content>
                            <v-list-tile-title class="font-weight-bold primary--text">
                                {{ $vuetify.t(subGroup.text) }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                        <!--                        <v-list-tile-title  v-text="sublink.text"/>-->
                    </v-list-tile>

                </v-list-group>
            </template>
        </v-list>

        <!-- @modified ana.castro 2019.12.19 SCLAPP-23 Display a URL to the Social Networks (FB and IG)-->
        <div class="menu-social-links">
            <a v-if="this.socialNetworkFacebook" :href=this.socialNetworkFacebook target="_blank" title="Facebook">
                <v-icon class="primary--text">fab fa-facebook-square</v-icon>
            </a>
            <a v-if="this.socialNetworkInstagram" :href=this.socialNetworkInstagram target="_blank"
               title="Instagram">
                <v-icon class="primary--text">fab fa-instagram</v-icon>
            </a>
        </div>
    </v-navigation-drawer>


</template>


<script>
    import {groupsService} from '@/_services/shop/groups.service';
    import {getErrorMessage} from '@/_helpers';
    import { mapGetters } from "vuex";

    export default {
        name: "Menu",
        props: {
            drawer: Boolean,
            cartNumberItems: Number,
            displayMenuCatalog: Boolean,
            logout: Function,
        },
        data() {
            return {
                drawerClone: this.drawer,
                generalMenuItems: [],
                shopMenuItems: [],
                socialNetworkFacebook: null,
                socialNetworkInstagram: null,
                loggedIn: false,
                // shopAvailable: Boolean,
            }
        },
        methods: {
            /**
             * Defining the items of the Generic Menu
             **/
            defineGeneralMenu() {
                this.generalMenuItems = {
                    'home': {icon: 'fal fa-home', text: '$vuetify.home', route: "/home", enabled: true},
                    'divider1': {divider: true},
                    'profile': {icon: 'fal fa-user-circle', text: '$vuetify.user', route: "/user", enabled: true},
                    'divider2': {divider: true},
                    'catalog': {
                        icon: 'fal fa-shopping-cart',
                        text: '$vuetify.shop.catalog',
                        route: "/catalog",
                        enabled: true
                    },
                    'divider3': {divider: true},
                    'highlights': {
                        icon: 'fal fa-star',
                        text: '$vuetify.highlights',
                        route: "/highlights",
                        enabled: true
                    },
                    'stores': {
                        icon: 'fal fa-map-marker-alt ',
                        text: '$vuetify.stores',
                        route: "/stores/list",
                        enabled: true
                    },
                    'offers': {icon: 'fal fa-gift', text: '$vuetify.offers', route: "/offers", enabled: true},
                    'purchases': {
                        icon: 'fal fa-history',
                        text: '$vuetify.transactions',
                        route: "/purchases",
                        enabled: true
                    },
                    'divider4': {divider: true},
                    'info': {icon: 'fal fa-info', text: '$vuetify.info', route: "/info/options", enabled: true},
                    'logout': {
                        icon: 'fal fa-sign-out-alt',
                        text: '$vuetify.authentication.logout',
                        function: "logout_emit",
                        enabled: true
                    },
                };
                //Some of the Menu items can be defined as being disabled.
                // This definition is given by the configurations defined on the store.
                this.updateMenu(this.$store.state);
            },
            /**
             * This function defines the structure of the menu for the given group.
             * @param group
             * @returns {{route: string, icon: string, text: *, enabled: boolean}}
             */
            defineShopMenuGroup: function (group) {
                var menuItem = {
                    'icon': null,
                    'text': group.description,
                    'route': group.sub_groups && group.sub_groups.length > 0 ? '/catalog/' + group.id : '/catalog/group/' + group.id,
                    'enabled': true,
                    'id': group.id
                };

                if (group.sub_groups && group.sub_groups.length > 0) {
                    var menuSubGroups = [];
                    for (var j = 0; j < group.sub_groups.length; j++) {
                        menuSubGroups.push(this.defineShopMenuGroup(group.sub_groups[j]));
                    }
                }
                menuItem['subgroups'] = menuSubGroups;

                return menuItem;
            },
            /**
             * Defining the items of the Shop Menu
             */
            defineShopMenu() {
                if (this.shopAvailable) {
                    groupsService.getAll({level: 1}).then(result => {
                            this.itemsCatalog = result.results;
                            this.$store.dispatch("loader/setLoading", false);

                            this.shopMenuItems.push({
                                'icon': 'fal fa-home',
                                'text': '$vuetify.home',
                                'route': "/home",
                                'enabled': true
                            });

                            this.shopMenuItems.push({
                                'divider': true
                            });

                            this.shopMenuItems.push({
                                'icon': 'fal fa-history',
                                'text': '$vuetify.shop.my_orders',
                                'route': "/orders",
                                'enabled': true
                            });

                            this.shopMenuItems.push({
                                'divider': true
                            });

                            this.shopMenuItems.push({
                                icon: 'fal fa-shopping-cart',
                                text: '$vuetify.shop.catalog',
                                route: "/catalog",
                                enabled: true
                            });


                            for (var i = 0; i < this.itemsCatalog.length; i++) {
                                this.shopMenuItems.push(this.defineShopMenuGroup(this.itemsCatalog[i]))
                            }

                            this.shopMenuItems.push({
                                'divider': true
                            });

                            this.shopMenuItems.push({
                                icon: 'fal fa-sign-out-alt',
                                text: '$vuetify.authentication.logout',
                                function: "logout_emit",
                                enabled: true
                            });
                        },
                        error => {
                            getErrorMessage(error, 'Getting the Groups', this);
                        }
                    );
                }
            },
            /**
             * Some of the Menu's items can be defined as being disabled.
             * This definition is given by the configurations defined on the store.
             **/
            updateMenu(state) {
                this.generalMenuItems['highlights']['enabled'] = state.configs.highlightsMenu;
                this.generalMenuItems['stores']['enabled'] = state.configs.storesMenu;
                this.generalMenuItems['offers']['enabled'] = state.configs.offersMenu;
                this.generalMenuItems['purchases']['enabled'] = state.configs.purchasesMenu;
                // @modified ana.castro 2019.12.30 SCLAPP-23
                this.generalMenuItems['info']['enabled'] = !!(state.configs.helpMenu || state.configs.termsConditionsMenu);
                // @modified ana.castro 2019.09.30 SCLAPP-22
                this.qrcodeAvailable = state.configs.qrcodeMenu;
                // @modified ana.castro 2020.10.14 SCLAPP-33
                // this.generalMenuItems['catalog']['enabled'] = state.configs.shopAvailable;
                this.generalMenuItems['catalog']['enabled'] = this.shopAvailable;
                // this.generalMenuItems['divider2']['divider'] = state.configs.shopAvailable;
                this.generalMenuItems['divider2']['divider'] = this.shopAvailable;
                this.generalMenuItems['divider4']['divider'] = state.configs.purchasesMenu || state.configs.offersMenu
                    || state.configs.storesMenu || state.configs.highlightsMenu;
            },
            // @modified ana.castro 2019.12.19 SCLAPP-23 Display a URL to the Social Networks (FB and IG)
            updateSocialNetwork(state) {
                this.socialNetworkFacebook = state.configs.socialNetworkFacebook;
                this.socialNetworkInstagram = state.configs.socialNetworkInstagram;
            },
            handle_function_call(function_name) {
                this[function_name]()
            },
            logout_emit() {
                this.$emit('logout')
            },
        },
        watch: {
            drawer() {
                this.drawerClone = this.drawer
            },
            drawerClone() {
                if (this.drawerClone !== this.drawer) {
                    this.$emit('changeDrawer', this.drawerClone);
                }
            }
        },
        computed: {
            /**
             * This function defines the content of the Menu. The Menu should display the Generic Menu or the Shop Menu?
             * This definition is based on the flag displayMenuCatalog which identifies whether or not the user is on
             * a Shop or on a Generic interface.
             * @returns {[]}
             */
            items: function () {
                if (this.displayMenuCatalog) {
                    return this.shopMenuItems
                } else {
                    return this.generalMenuItems
                }
            },
          ...mapGetters({
            shopAvailable: "configs/shopAvailable",
          }),
        },
        mounted() {
            //Since a Prop must not be mutate this was the workaround found
            this.drawerClone = this.drawer;

            this.updateSocialNetwork(this.$store.state);

            this.$store.subscribe((mutation, state) => {
                switch (mutation.type) {
                    case 'configs/setGeneralConfig':
                        this.updateMenu(state);
                        // @modified ana.castro 2019.12.19 SCLAPP-23 Display a URL to the Social Networks (FB and IG)
                        this.updateSocialNetwork(state);
                        break;
                }
            });

            // @modified ana.castro 2019.12.03 The Login interface must display a link to access the Terms and Conditions
            // In case a Non Authenticated User access the Terms and Conditions page, the menu should not be displayed
            this.loggedIn = localStorage.getItem('user');

            //Defining the content of each Menu (General Menu and the Shop Menu)
            this.defineGeneralMenu();

            this.defineShopMenu();
        },
    }
</script>

<style lang="stylus">
    #keep
        .v-navigation-drawer__border
            display: none

    .menu-social-links
        text-align center
        margin-top 30px

        a
            text-decoration: none
            margin-right 20px
            margin-left 20px

        i
            width: 24px
            font-size: 30px
</style>